import React, { useEffect } from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateBranchesStatusReduxParams } from '~types/feat/approval';

import { BranchApprovalStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateBranchesStatusModal.module.scss';

const ConfirmUpdateBranchesStatusModal = () => {
    const isOpen = useAppSelector(state => state.approval.modals.confirmUpdateBranchesModalIsOpen);
    const tempUpdateBranchState = useAppSelector(state => state.approval.tempUpdateBranchesState);
    const isLoading = useAppSelector(state => state.approval.loadings.updateBranchesStatus);
    const error = useAppSelector(state => state.approval.errors.updateBranchesStatus);

    const getStatus = () => {
        switch (tempUpdateBranchState.status) {
            case (BranchApprovalStatusEnum.Approved): return 'Approve';
            case (BranchApprovalStatusEnum.Rejected): return 'Reject';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateBranchesStatusModalIsOpen(open));
    const updateBranchStatus = (data: TUpdateBranchesStatusReduxParams) => dispatch(combinedActions.approvalUpdateBranchesStatusAttempt(data));

    const handleSubmitClick = () => {
        updateBranchStatus(tempUpdateBranchState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Approve' ? Styles['confirm-approve'] : ''),
        (getStatus() === 'Reject' ? Styles['confirm-reject'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetUpdateBranchesStatusState());
        }

        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()} Branch?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                    disabled={isLoading}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmUpdateBranchesStatusModal;
